import { IGetFornecedorAvaliacaoItensByIdUseCase } from "../../../presentation/useCases/read/get_fornecedor_avaliacao_itens_by_id_use_case";
import { FornecedorAvaliacaoItem } from "../../models/fornecedor_avaliacao_item";
import { IComprasRepository } from "../../repositories/compras_repositories";

/**
 * GetFornecederAvaliacaoItensByIdUseCase
 */

export class GetFornecedorAvaliacaoItensByIdUseCase implements IGetFornecedorAvaliacaoItensByIdUseCase {
  constructor(private readonly repository: IComprasRepository) { }

  async getFornecedorAvaliacaoItensById(
    idAvaliacaoFornecedor: number,
  ): Promise<FornecedorAvaliacaoItem[]> {
    return await this.repository.getFornecedorAvaliacaoItensById(
      idAvaliacaoFornecedor,
    );
  }
}
